import { render, staticRenderFns } from "./ProductModalComponent.vue?vue&type=template&id=014ad32b&scoped=true&"
import script from "./ProductModalComponent.vue?vue&type=script&lang=js&"
export * from "./ProductModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014ad32b",
  null
  
)

export default component.exports